import React, { useEffect, useState } from 'react';
import loader from 'src/assets/images/loading.json';
import read from 'src/assets/images/read.json';
import jwt from 'jwt-decode';
import error from 'src/assets/images/error.json';
import { useSelector, useDispatch } from 'react-redux';
import success from 'src/assets/images/success.json';
import { ReactComponent as DltLogo } from 'src/assets/images/delete.svg';
import Lottie from 'react-lottie';
import { Tooltip } from 'antd';
import { get } from 'lodash';
import newAlert from 'src/components/newAlert';

const typeList = {
  error: {
    text: 'Алдаатай',
    svg: error,
  },
  read: {
    text: 'Уншуулах',
    svg: read,
  },
  success: {
    text: 'Уншигдсан',
    svg: success,
  },
  loader: {
    text: 'Ачааллаж байна',
    svg: loader,
  },
  delete: {
    text: 'Устгах',
  },
};

const CustomIcon = ({ type = 'error', row = [], onClick = () => {} }) => {
  const dispatch = useDispatch();
  const [currentType, setCurrentType] = useState(type);
  const loading = useSelector((state) => state.is_loading);

  // Update type based on props and row
  useEffect(() => {
    let value = type;
    if (type === 'read' && row.includes(1)) {
      value = 'loader';
    }
    setCurrentType(value);
  }, [type, row]);

  // Update type based on loading state
  useEffect(() => {
    if (loading === 'start' && currentType === 'read') {
      setCurrentType('loader');
    } else if (loading === 'done') {
      setCurrentType(type);
    }
  }, [loading, type]);

  if (!currentType) return null;

  const handleClick = () => {
    if (loading === 'start') {
      const jwt_token = localStorage.getItem('taxjwt');
      console.log('🚀 ~ CustomIcon ~ jwt_token:', jwt_token);

      try {
        const jwt_decoded = jwt(jwt_token);
        console.log('🚀 ~ CustomIcon ~ jwt_decoded:', jwt_decoded);

        const { user_type } = jwt_decoded;
        console.log('🚀 ~ CustomIcon ~ user_type:', user_type);

        if (user_type === 2) {
          onClick(); // Call the onClick function for user_type === 2
        } else {
          newAlert({
            type: 'warning',
            msg: 'Ачааллаж байна файл уншигдаж дууссаны дараа дахин оролдоно уу',
          });
        }
      } catch (err) {
        console.error('JWT decode error:', err);
        newAlert({
          type: 'error',
          msg: 'Токен алдаатай байна, дахин нэвтэрнэ үү',
        });
      }
    } else {
      onClick(); // Call onClick if loading is not 'start'
    }
  };

  return (
    <Tooltip title={get(typeList, `${currentType}.text`, null)}>
      {get(typeList, `${currentType}.svg`, null) ? (
        <div className="click-div" onClick={handleClick}>
          <Lottie
            options={{
              animationData: get(typeList, `${currentType}.svg`, null),
            }}
          />
        </div>
      ) : (
        <DltLogo
          style={{
            cursor: 'pointer',
          }}
          onClick={handleClick} // Use camelCase onClick
        />
      )}
    </Tooltip>
  );
};

export default CustomIcon;
